import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import Parse from 'parse'

export default class SkillLevelDetail extends React.Component {
  constructor (props) {
    super(props)
    if (this.props.match.params.id && this.props.match.params.id !== 'new') {
      this.state = {
        isLoading: true,
        id: this.props.match.params.id,
        editing: false,
        saving: false,
        numResults: -1,
        existingTags: [],
        existingSkillLevel: []
      }
      this.loadSkillLevel()
    } else {
      // When `id` is "new", we are intending to make a new Exercise object.
      // This makes a new one and sets the mode to editing right away
      const skill = new Parse.Object('SkillLevel')
      this.state = {
        isLoading: false,
        SkillLevel: skill,
        editing: true,
        saving: false,
        numResults: -1,
        existingTags: [],
        existingSkillLevel: []
      }
    }

    this.loadSkillLevel()
  }

  loadSkillLevel = () => {
    const SkillLevelType = new Parse.Object('SkillLevel')
    const query = new Parse.Query(SkillLevelType)
    query.equalTo('objectId', this.state.id)
    console.log('load SkillLevel with id: ' + this.state.id)
    query.first().then((result) => {
      this.setState({
        SkillLevel: result,
        isLoading: false
      })
    }, (error) => {
      console.log(error)
      window.alert('Error fetching SkillLevel')
    })
  }

  handleEdit = () => {
    const newEditing = !this.state.editing
    this.setState({
      editing: newEditing
    })
  }

  handleSave = async (event) => {
    event.preventDefault()
    this.setState({
      saving: true
    })
    await this.saveSkillLevel()
    if (this.state.id) {
      window.location.reload()
    } else {
      window.location.href = '/#/skilllevels/' + this.state.SkillLevel.id
      window.location.reload()
    }
  }

  saveSkillLevel = async () => {
    if (this.state.SkillLevel.get('enumValue') === undefined) {
      this.state.SkillLevel.set('enumValue', this.state.numResults)
    }
    return await this.state.SkillLevel.save()
  }

  handleCancel = (event) => {
    event.preventDefault()
    window.location.reload()
  }

  handleNameChange = (event) => {
    this.state.SkillLevel.set('name', event.target.value)
  }

  handleDescriptionChange = (event) => {
    this.state.SkillLevel.set('description', event.target.value)
  }

  handleTypeChange = (event) => {
    this.state.SkillLevel.set('type', event.target.value)
  }

  handleNew = async (event) => {
    const newKey = prompt('Please enter a key name for this SkillLevel. Careful- you can\'t change it once it\'s set! Must be a number.\n\nEx: 1, 2, 33')
    if (!newKey) return
    const newName = prompt('Please enter the name of the SkillLevel. Members will see this name.')
    if (!newName) return
    const newObj = new Parse.Object('SkillLevel')
    newObj.set('key', parseInt(newKey))
    newObj.set('name', newName)
    await newObj.save()
    window.location.href = '/#/skilllevels/' + newObj.id
    window.location.reload()
  }

  getEditButtons = () => {
    if (this.state.editing) {
      return (
        <div>
            <button className="btn btn-success" onClick={this.handleSave} disabled={this.state.saving}>Save</button>
        </div>
      )
    }

    return (
      <div>
          <button type="button" className="btn btn-secondary" onClick={this.handleEdit}>Edit</button>
          &nbsp;&nbsp;
          <button type="button" className="btn btn-primary" onClick={this.handleNew}>New</button>
      </div>
    )
  }

  renderNotEditing = (SkillLevel) => {
    return (
      <div className="container">
        <br/>
        <div className="row">
          <div className="col">
            <h1>
              {SkillLevel.get('name')} <small className="text-muted">{SkillLevel.id}</small>
            </h1>
          </div>
          <div className="col text-end">
            {this.getEditButtons()}
          </div>
        </div>
        <br/>
        <div className="row">
          <div className="col">
            <p>
              <b>Key:</b><br/>
              <span className="text-muted"><code>{SkillLevel.get('key')}</code></span>
              <p><b>Description:</b><br/>
              <span className="text-muted">{SkillLevel.get('description')}</span></p>
            </p>
          </div>
        </div>
      </div>
    )
  }

  renderEditing = (SkillLevel) => {
    return (
            <div className="container">
                <br/>
                <span className="text-muted">{SkillLevel.get('key')}</span>
                <br/>
                <hr/>
                <form>
                  <div className="mb-3">
                    <label><b>Name</b></label>
                    <input type="text" className="form-control" placeholder={SkillLevel.get('name')} defaultValue={SkillLevel.get('name')} onChange={this.handleNameChange}/>
                  </div>
                  <div className="mb-3">
                    <label><b>Description</b></label>
                    <input type="text" className="form-control" placeholder={SkillLevel.get('description')} defaultValue={SkillLevel.get('description')} onChange={this.handleDescriptionChange}/>
                  </div>
                  <button type="submit" className="btn btn-success" onClick={this.handleSave} disabled={this.state.saving} >Save</button>
                  <br/><br/>
                  <button type="submit" className="btn btn-secondary" onClick={this.handleCancel} disabled={this.state.saving} >Cancel</button>
                </form>
            </div>
    )
  }

  render = () => {
    if (this.state.SkillLevel === undefined) {
      return (<div>Loading...</div>)
    }
    const video = this.state.SkillLevel

    return this.state.editing ? this.renderEditing(video) : this.renderNotEditing(video)
  }
}
